import { IcDataList, IcDownload } from '@assets/icons/32x32';
import { Center, HStack, Icon, Separator, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveSite } from '@redux/authent/authent.selectors';
import { useGetSensorLogsMutation } from '@services/c2/c2.api';
import { createDownloadToast, exportFileOrDirectory } from '@utils/importExport.utils';
import { FunctionComponent, SVGProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { DownloadToastTypeEnum } from '@/types/download.types';

type listButtonProps = {
  label: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  disabled?: boolean;
  onClick: () => void;
};

function ListButton({ label, icon, disabled = false, onClick }: Readonly<listButtonProps>) {
  return (
    <HStack
      width="100%"
      height="min-content"
      paddingY={2}
      className="group"
      cursor={disabled ? 'default' : 'pointer'}
      gap={0}
      backgroundColor="neutral.700"
      _hover={disabled ? undefined : { backgroundColor: 'neutral.600' }}
      onClick={() => !disabled && onClick()}
    >
      <Center padding={3}>
        <Icon as={icon} boxSize="32px" color="neutral.300" _groupHover={disabled ? undefined : { color: 'skyBlue' }} />
      </Center>
      <Separator height="80px" orientation="vertical" borderColor="neutral.850" size="md" />
      <Text paddingX={4} flex={1}>
        <FormattedMessage id={`components.popups.engagement.${label}`} />
      </Text>
    </HStack>
  );
}

export default function EngagementReports({ id }: Readonly<{ id: string | null }>) {
  const [submitExportLogs] = useGetSensorLogsMutation();
  const site = useAppSelector(selectActiveSite)?.code;

  const download = async () => {
    if (!site || !id) {
      throw new Error('Invalid parameters!');
    }
    try {
      const response = await submitExportLogs({ site, id });
      exportFileOrDirectory(response);
    } catch (_) {
      createDownloadToast(DownloadToastTypeEnum.ERROR);
    }
  };

  return (
    <VStack backgroundColor="neutral.900" boxSize="100%" gap={0.25}>
      <ListButton
        label="jammingReport"
        icon={IcDataList}
        disabled
        onClick={() => console.log('Générer un rapport de brouillage')}
      />
      <ListButton label="jammingLogs" icon={IcDownload} onClick={download} />
      <ListButton
        label="commandLogs"
        icon={IcDownload}
        onClick={() => console.log('Télécharger les logs de commande')}
      />
    </VStack>
  );
}
